import addRequestNetworkAction from '../../../../network/actions/add-request'
import REDUX_ACTION from '../../../../redux/constants/action'

/**
 * Sets the given `path` status as loading.
 * @private
 * @param {Object} action
 *        {string} payload.type
 *        {string} payload.path
 */
export default function loadingReduxAction (action) {
  return (dispatch) => {
    // loadingReduxActionLogger.debug(action)
    dispatch({
      type: action.type,
      reduxType: REDUX_ACTION.LOAD,
      payload: action.payload
    })
    dispatch(addRequestNetworkAction(action))
  }
}
